module.exports = __webpack_public_path__ + "91396a4bcf9c080127ea1f02654e7a21.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/azat-mardan.jpg
 ** module id = 401
 ** module chunks = 0
 **/